import useTestId from '@ori/testid-generator';
import { FormControlLabel, Radio } from '@ori-ui/mui';
import type { FC, FormEvent } from 'react';
import React from 'react';

import { NOTIFY_TYPE } from './constants';
import { Root } from './styles';
import { useAppContext, useTranslations } from '../../hooks';
import { BackInStockNotificationChannel } from '../../models';

export interface NotifyTypeProps {
  currentType: string;
  onChange: (event: FormEvent<HTMLInputElement>) => void;
}

export const NotifyType: FC<NotifyTypeProps> = ({ currentType, onChange }) => {
  const { getTestId } = useTestId();
  const { notifyMeSubscriptionConfiguration } = useAppContext();
  const { translations } = useTranslations();

  if (!notifyMeSubscriptionConfiguration.IsSmsSubscriptionEnabled) {
    return null;
  }

  return (
    <Root
      aria-label={translations.chooseAnOption}
      data-testid={getTestId(NOTIFY_TYPE)}
      name="pdp-notify-choose"
      value={currentType}
      onChange={onChange}
    >
      <FormControlLabel
        id="pdp-notify-email"
        value={BackInStockNotificationChannel.Email}
        control={<Radio color="primary" />}
        label={translations.email}
      />
      <FormControlLabel
        id="pdp-notify-sms"
        value={BackInStockNotificationChannel.Sms}
        control={<Radio color="primary" />}
        label={translations.sms}
      />
    </Root>
  );
};
